import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import LinkButton from "components/LinkButton";
import asset from "helpers/cdn";
import CopyToClipboard from "react-copy-to-clipboard";
import { FiCheck } from "@react-icons/all-files/fi/FiCheck";
import { FiCopy } from "@react-icons/all-files/fi/FiCopy";
import useShareImage from "../../hooks/useShareImage";
import SharePreview from "../SharePreview/SharePreview";
function StoryShare({ shareItem, canNativeShare, isMobileDevice, buildShareData, }) {
    const [copied, setCopied] = useState(false);
    const shareUrlObject = new URL(shareItem.url);
    shareUrlObject.searchParams.set("utm_medium", "instagram-story");
    const shareUrl = shareUrlObject.toString();
    const { imageSrc, imageBlob, imageError, downloadImage, } = useShareImage({
        shareItem,
        shareUrl,
        showLinkPlaceholder: true,
    });
    const canAutoShare = canNativeShare && isMobileDevice;
    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    const handleOpenInstagram = async () => {
        var _a;
        try {
            await ((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(shareUrl));
        }
        catch (_b) {
            // Ignore clipboard failures - share the link anyway.
        }
        navigator.share(buildShareData(shareUrl, imageBlob)).catch(() => { });
    };
    const getSteps = () => {
        const steps = [];
        if (!canAutoShare) {
            steps.push(...[
                {
                    caption: "Download the image above to your device",
                    imageUrl: asset("images/share/instagram/download-image.png"),
                },
                {
                    caption: "Open Instagram and start a new story",
                    imageUrl: asset("images/share/instagram/open-app.png"),
                },
            ]);
        }
        steps.push(...[
            {
                caption: "Select the sticker icon",
                imageUrl: asset("images/share/instagram/click-sticker.png"),
            },
            {
                caption: "Choose the link sticker",
                imageUrl: asset("images/share/instagram/choose-link.png"),
            },
            {
                caption: "Add the link sticker on your story",
                imageUrl: asset("images/share/instagram/add-link.png"),
            },
        ]);
        return steps;
    };
    return (_jsxs("div", { className: "share-modal__instagram-post-content", children: [_jsx(SharePreview, { imageSrc: imageSrc, imageError: imageError, onDownload: downloadImage }), _jsx("h4", { className: "share-modal__instagram-title", children: "Ready to share to your Instagram story" }), _jsx("p", { className: "share-modal__instagram-description", children: "Here's how to add a link to your story:" }), _jsx("ol", { className: "share-modal__instagram-steps", children: getSteps().map((step, index) => (_jsxs("li", { className: "share-modal__instagram-step", children: [_jsxs("div", { className: "share-modal__instagram-step-content", children: [_jsx("span", { className: "share-modal__instagram-step-number", children: index + 1 }), _jsx("p", { className: "share-modal__instagram-step-text", children: step.caption })] }), _jsx("img", { src: step.imageUrl, alt: "", className: "share-modal__instagram-step-image" })] }, step.caption))) }), _jsxs("div", { className: "share-modal__instagram-description", children: ["Don't forget to copy the URL:", _jsx(CopyToClipboard, { text: shareUrl, onCopy: handleCopy, children: _jsxs("button", { type: "button", className: "share-modal__instagram-codeblock", "aria-label": "Copy link to clipboard", children: [_jsx("span", { className: "share-modal__instagram-codeblock-text", "data-testid": "copy-instagram-caption", children: shareUrl }), copied
                                    ? _jsx(FiCheck, { className: "share-modal__copy-icon--copied" })
                                    : _jsx(FiCopy, { className: "share-modal__copy-icon" })] }) })] }), canAutoShare && (_jsx("p", { className: "share-modal__instagram-footer", children: _jsx(LinkButton, { isBold: true, look: "primary", onClick: handleOpenInstagram, size: "large", "data-testid": "open-instagram-button", isFullWidth: true, children: "Open Instagram" }) }))] }));
}
export default StoryShare;
